import { render, staticRenderFns } from "./DoorAssignment.vue?vue&type=template&id=10fef5da"
import script from "./DoorAssignment.vue?vue&type=script&lang=js"
export * from "./DoorAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports